export const NotificationRouteENUM = {
  CENTER_UNIVERSITY: {
    route: '/user/notification-list'
  },
  LOADED_REPORT: {
    route: '/user/category-reports'
  },
  PUBLIC_SERVICES: {
    route: '/user/ps'
  },
  convertQueryParams(queryString) {
    const obj = {};
    const pairs = queryString.split('&');
    for (let i = 0; i < pairs.length; i++) {
      const split = pairs[i].split('=');
      obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
    }
    return obj;
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/user/enums/notification-route.enum.ts